import { lazy } from "react";
import { Route } from "react-router-dom";
import RouteGuard from "@/components/RouteGuard";

const DevDashboard = lazy(() => import("@/pages/DevDashboard"));
const DevManualCompleto = lazy(() => import("@/pages/DevManualCompleto"));
const DevApresentacoes = lazy(() => import("@/pages/DevApresentacoes"));
const DevOrganograma = lazy(() => import("@/pages/DevOrganograma"));
const DevInspecao = lazy(() => import("@/pages/DevInspecao"));
const DevNotebookLMExport = lazy(() => import("@/pages/DevNotebookLMExport"));
const DevMigracaoBoxe = lazy(() => import("@/pages/DevMigracaoBoxe"));
const DevMigracaoPiloto = lazy(() => import("@/pages/DevMigracaoPiloto"));

const G = ({ children }: { children: React.ReactNode }) => (
  <RouteGuard allowedRoles={["developer"]}>{children}</RouteGuard>
);

export const devRoutes = (
  <>
    <Route path="/dev_dashboard" element={<G><DevDashboard /></G>} />
    <Route path="/dev_manual" element={<G><DevManualCompleto /></G>} />
    <Route path="/dev_apresentacoes" element={<G><DevApresentacoes /></G>} />
    <Route path="/dev_organograma" element={<G><DevOrganograma /></G>} />
    <Route path="/dev_inspecao" element={<G><DevInspecao /></G>} />
    <Route path="/dev_notebook_export" element={<G><DevNotebookLMExport /></G>} />
    <Route path="/dev_migracao_boxe" element={<G><DevMigracaoBoxe /></G>} />
    <Route path="/dev_migracao_piloto" element={<G><DevMigracaoPiloto /></G>} />
  </>
);
